var _defs, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddresses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg3747",
    viewBox: "0 0 34 34",
    height: 34,
    width: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3734"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 16.586,9.297 a 0.75,0.75 0 0 0 -0.44,0.965 4.255,4.255 0 0 1 -3.982,5.739 4.255,4.255 0 0 1 -4.25,-4.25 4.254,4.254 0 0 1 6.44,-3.644 0.75005016,0.75005016 0 0 0 0.774,-1.285 5.748,5.748 0 0 0 -2.963,-0.82 5.756,5.756 0 0 0 -5.75,5.75 c 0,3.17 2.579,5.75 5.75,5.75 A 5.757,5.757 0 0 0 17.551,9.736 0.749,0.749 0 0 0 16.586,9.297 m 2.233,13.204 c -0.293,0.492 -0.592,0.994 -0.894,1.51 a 108.48,108.48 0 0 1 -1.277,2.125 135.105,135.105 0 0 1 -3.453,5.317 c -0.472,0.695 -1.588,0.695 -2.061,0 L 10.98,31.229 C 7.903,26.709 1.5,17.308 1.5,12.165 1.5,6.285 6.284,1.5 12.165,1.5 c 5.88,0 10.665,4.784 10.665,10.664 0,3.6 -1.77,6.573 -4.011,10.337 M 12.165,0 C 5.457,0 0,5.457 0,12.165 0,17.77 6.337,27.074 9.74,32.072 l 0.154,0.225 a 2.745,2.745 0 0 0 4.542,0 c 0.534,-0.784 1.167,-1.73 1.848,-2.78 0.525,-0.81 1.079,-1.683 1.64,-2.595 0.432,-0.698 0.867,-1.42 1.296,-2.154 0.3,-0.512 0.597,-1.01 0.888,-1.498 C 22.374,19.464 24.33,16.177 24.33,12.165 24.33,5.458 18.873,0 12.165,0",
    id: "a"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd"
    },
    transform: "translate(5.2862191,0.28032981)",
    id: "g3745"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    y: 0,
    x: 0,
    id: "use3736",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    y: 0,
    x: 0,
    style: {
      fill: "#000000"
    },
    id: "use3739",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#636176"
    },
    id: "g3743",
    mask: "url(#b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3741",
    d: "M -11,-8 H 37 V 40 H -11 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddresses);
export default __webpack_public_path__ + "static/media/addresses.978316b9be957415fb3c67a9448da954.svg";
export { ForwardRef as ReactComponent };